import styled from "styled-components";
import {
	COLOR_TEXT_PRIMARY_B2C,
	MOBILE_L_BP,
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
	TABLET_BP,
	COLOR_HYPERLINK,
} from "@website-builder/utilities-index";

export const Container = styled.div`
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	padding: 85px 0 40px 0px;
	padding-top: 120px;
	color: ${COLOR_TEXT_PRIMARY_B2C};

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 120px 10px 40px 10px;
	}

	@media only screen and (max-width: ${TABLET_BP}px) {
		padding: 70px 10px 40px 10px;
	}

	@media only screen and (max-width: ${TABLET_BP}px) {
		${(props) => (props.showInTabletAndMobile ? "" : "display: none")}
	}
`;

export const Header = styled.h2`
	max-width: 825px;
	font-size: 36px;
	line-height: 1.22;
	margin: 0px;
	font-weight: ${FONT_WT_MEDIUM};

	@media only screen and (max-width: ${TABLET_BP}px) {
		font-size: 32px;
		font-weight: ${FONT_WT_MEDIUM};
		line-height: 1.38;
		margin: auto;
		max-width: 500px;
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		font-size: 28px;
		line-height: 1.39;
		font-weight: ${FONT_WT_MEDIUM};
	}
`;

export const SubHeader = styled.div`
	max-width: 815px;
	font-size: 16px;
	font-weight: ${FONT_WT_LIGHT};
	line-height: 1.63;

	a {
		color: ${COLOR_HYPERLINK};
	}
	a:visited {
		text-decoration: none;
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding-left: 10px;
		padding-right: 10px;
	}

	@media only screen and (max-width: ${TABLET_BP}px) {
		max-width: 653px;
	}
	p {
		margin: 0px;
		margin-top: 30px;
	}
`;
